type JsonExportProps = {
  filename: string
  content: unknown
  onSuccess?: () => void
  onError?: (error: unknown) => void
}

export function jsonExport({ filename, content, onSuccess, onError }: JsonExportProps) {
  if (typeof window === 'undefined') return

  let href: string | null = null

  try {
    const jsonString = JSON.stringify(content, null, 2)
    const blob = new Blob([jsonString], { type: 'application/json' })
    href = URL.createObjectURL(blob)
    const link = window.document.createElement('a')

    link.href = href
    link.download = filename
    window.document.body.appendChild(link)
    link.click()

    window.document.body.removeChild(link)
    onSuccess?.()
  } catch (error) {
    onError?.(error)
  } finally {
    if (href) URL.revokeObjectURL(href)
  }
}
